document.addEventListener(
	"DOMContentLoaded",
	function () {
		const form                = document.querySelector( 'form[action*="wp-login.php?action=postpass"]' );
		const isPasswordProtected = form !== null;

		/**
		 * Update the URL with the custom fields as query parameters
		 */
		const updateUrlWithCustomFields = () => {
			const url                   = new URL( window.location.href );
			const inputs                = document.querySelectorAll( '[name^="ig_"]' );
			inputs.forEach(
				(input) => {
                url.searchParams.set( input.name, input.value );
				}
			);
		window.history.replaceState( null, document.title, url.toString() );
		};

		/**
		 * Store the custom fields in local storage
		 */
		const storeCustomFieldsInLocalStorage = () => {
			const inputs                      = document.querySelectorAll( '[name^="ig_"]' );
			const customFields                = {};
			inputs.forEach(
				(input) => {
                customFields[input.name]  = input.value;
				}
			);
		localStorage.setItem( 'custom_fields', JSON.stringify( customFields ) );
		};

		/**
		 * Populate the custom fields from local storage
		 */
		const populateCustomFieldsFromLocalStorage = () => {
			const customFields                     = JSON.parse( localStorage.getItem( 'custom_fields' ) );
			if (customFields) {
				const inputs = document.querySelectorAll( '[name^="ig_"]' );
				inputs.forEach(
					(input) => {
						if (customFields[input.name]) {
							input.value = customFields[input.name];
						}
					}
				);
			}
		};

		if (isPasswordProtected) {
			form.addEventListener(
				'submit',
				function () {
					updateUrlWithCustomFields();
					storeCustomFieldsInLocalStorage();
				}
			);

			form.addEventListener(
				'input',
				function () {
					updateUrlWithCustomFields();
					storeCustomFieldsInLocalStorage();
				}
			);

			populateCustomFieldsFromLocalStorage();
		} else {
			const url    = new URL( window.location.href );
			const inputs = document.querySelectorAll( '[name^="ig_"]' );
			inputs.forEach(
				(input) => {
					url.searchParams.delete( input.name );
				}
			);
			window.history.replaceState( null, document.title, url.toString() );

			populateCustomFieldsFromLocalStorage();
		}
	}
);
